export default "__VITE_ASSET__71d61219__"